import { Icon, ospThemes } from "@ospweb/sdk-ui";
import { cn } from "utils";
import { useState } from "react";
import { EdgenModalCreateAble } from "../EdgenModal";
import Translations from "@translate/components/Setting/DisConnectModal";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

type DisConnectModalProps = {
  title: string;
  description: string;
  loading?: boolean;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const DisConnectModal = (props: DisConnectModalProps) => {
  const { onClose, onConfirm, title, description } = props;
  const [isLoading, setIsLoading] = useState(false);
  const handleConfirm = async () => {
    setIsLoading(true);
    await onConfirm();
    setIsLoading(false);
  };
  return (
    <div className="px-6 pt-6 pb-3 bg-background_solid_secondary flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <div className="headline_regular_s text-content_primary">{title}</div>
        <div className="body_m text-content_secondary">{description}</div>
      </div>
      <div className="flex gap-2 justify-end">
        <button
          aria-label="Dis Connect Modal"
          data-openreplay-label={`Dis Connect Modal Button | ${I18n.t("Cancel")}`}
          id="btn-dis-connect-modal"
          className="sm_button button secondary_button text-content_primary button_m"
          disabled={isLoading}
          onClick={onClose}
        >
          {I18n.t("Cancel")}
        </button>
        <button
          aria-label="Dis Connect Modal"
          data-openreplay-label="Dis Connect Modal Button"
          id="btn-dis-connect-modal-2"
          className="sm_button min-w-[76px] button primary_button text-content_inverse_primary button_m group"
          data-loading={isLoading}
          onClick={handleConfirm}
        >
          <span className="group-loading:hidden">{I18n.t("Confirm")}</span>
          <Icon
            name="ic_loading2"
            size={20}
            color={ospThemes.colors.content_inverse_primary}
            className={cn("hidden animate-spin group-loading:block")}
          />
        </button>
      </div>
    </div>
  );
};

export const DisConnectModalCallable = async (props: any) => {
  const { modalProps, ...otherProps } = props;
  return new Promise<any>((resolve) => {
    EdgenModalCreateAble.call({
      children: (
        <DisConnectModal
          onClose={() => {
            EdgenModalCreateAble.end(false);
            resolve(undefined);
          }}
          {...otherProps}
        />
      ),
      onCancel: () => EdgenModalCreateAble.end(false),
      containerClassName: "!md:w-[400px] !md:rounded-[16px]",
      styles: {
        content: {
          backgroundColor: ospThemes.colors.background_solid_secondary,
          padding: 0,
          borderRadius: "16px",
          overflow: "hidden",
        },
      },
      centered: true,
      destroyOnClose: true,
      ...modalProps,
    });
  });
};
